"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const useFetch_1 = __importDefault(require("./useFetch"));
class BackendCall {
    constructor(baseApiUrl, defaultHeaders = {}, defaultSuccessFunction = (res) => res, defaultErrorFunction = (err) => err, useFetchConfig = { promiseReject: true, promiseResolve: true }) {
        this.baseApiUrl = baseApiUrl;
        this.defaultHeaders = defaultHeaders;
        this.defaultSuccessFunction = defaultSuccessFunction;
        this.defaultErrorFunction = defaultErrorFunction;
        this.useFetchConfig = useFetchConfig;
    }
    handleIsShortHanded(useFetchCustomConfig) {
        if (useFetchCustomConfig) {
            return useFetchCustomConfig;
        }
        else {
            return this.useFetchConfig;
        }
    }
    postData(config) {
        return (0, useFetch_1.default)(config.endPoint, 'POST', config.bodyDefault, config.queryDefault, this.baseApiUrl, this.defaultHeaders, this.defaultSuccessFunction, this.defaultErrorFunction, this.handleIsShortHanded(config.useFetchCustomConfig));
    }
    getData(config) {
        return (0, useFetch_1.default)(config.endPoint, 'GET', undefined, config.queryDefault, this.baseApiUrl, this.defaultHeaders, this.defaultSuccessFunction, this.defaultErrorFunction, this.handleIsShortHanded(config.useFetchCustomConfig));
    }
    updateData(config) {
        return (0, useFetch_1.default)(config.endPoint, 'PUT', config.bodyDefault, config.queryDefault, this.baseApiUrl, this.defaultHeaders, this.defaultSuccessFunction, this.defaultErrorFunction, this.handleIsShortHanded(config.useFetchCustomConfig));
    }
    patchData(config) {
        return (0, useFetch_1.default)(config.endPoint, 'PATCH', config.bodyDefault, config.queryDefault, this.baseApiUrl, this.defaultHeaders, this.defaultSuccessFunction, this.defaultErrorFunction, this.handleIsShortHanded(config.useFetchCustomConfig));
    }
    deleteData(config) {
        return (0, useFetch_1.default)(config.endPoint, 'DELETE', config.bodyDefault, config.queryDefault, this.baseApiUrl, this.defaultHeaders, this.defaultSuccessFunction, this.defaultErrorFunction, this.handleIsShortHanded(config.useFetchCustomConfig));
    }
    custom(config) {
        return (0, useFetch_1.default)(config.endPoint, config.method, config.bodyDefault, config.queryDefault, this.baseApiUrl, this.defaultHeaders, this.defaultSuccessFunction, this.defaultErrorFunction, this.handleIsShortHanded(config.useFetchCustomConfig));
    }
}
exports.default = BackendCall;
//# sourceMappingURL=BackendCall.js.map